import { render } from "./Accessories.vue?vue&type=template&id=1bb49088&scoped=true"
import script from "./Accessories.vue?vue&type=script&lang=js"
export * from "./Accessories.vue?vue&type=script&lang=js"

import "./Accessories.vue?vue&type=style&index=0&id=1bb49088&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb49088"]])

export default __exports__